export default __webpack_public_path__ + "static/media/responsiveroadmap3.542c0af3.png";